export const buildHomepageSliders = (homepageData, userData, recommendationsSliderPayload) => {
    const demoteSubsidySlider = userData?.demoteSubsidySlider || null;

    const transformSliderItem = (item) => {
        const transformed = {...item};
        const slider = {...transformed.slider};
        if (!slider.homepage_order_num) {
            slider.homepage_order_num = 0;
        }
        if (slider.is_subsidized) {
            slider.homepage_order_num = -1;
            if (demoteSubsidySlider) {
                const magazineSlider = homepageData.Sliders.find((sliderI) => {
                    return sliderI?.type_id == 5
                })
                if (magazineSlider) {
                    slider.homepage_order_num = magazineSlider.slider?.homepage_order_num - 1;
                }
            }
        }
        return {
            ...transformed,
            slider: slider
        }
    };

    let recEntry = userData ? recommendationsSliderPayload : null;
    let slidersTemp = (homepageData?.Sliders || []).map(transformSliderItem);
    if (recEntry) {
        slidersTemp = [transformSliderItem(recEntry), ...slidersTemp];
    }
    slidersTemp = slidersTemp.sort((s1, s2) => {
        return Number(s1.slider.homepage_order_num) - Number(s2.slider.homepage_order_num)
    });

    return slidersTemp.map((sliderData, sliderIndex) => ({
        ...sliderData,
        uniqueId: `homepage-slider_${sliderIndex}`,
    }));
};
